/*
----------------------------
Module - list-nav-major-link
----------------------------
*/

// import $ from 'jquery';
/*global fmg*/

// (function(){
//     'use strict';
    
    
// }());
